import { j as o } from "../../jsx-runtime.BREq8dyb.js";
import { faXmark as s } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon as t } from "@fortawesome/react-fontawesome";
import { styled as i, ModalClose as a, IconButton as p, useThemeProps as c } from "@mui/joy";
import { memo as r } from "react";
const n = "DqSidePanelClose", d = i(a, {
  name: n,
  slot: "root"
})(), f = r((e) => /* @__PURE__ */ o.jsx(p, { ...e, children: /* @__PURE__ */ o.jsx(t, { icon: s }) })), u = r((e) => {
  const {
    children: m = /* @__PURE__ */ o.jsx(t, { icon: s }),
    ...l
  } = c({
    name: n,
    props: e
  });
  return /* @__PURE__ */ o.jsx(d, { ...l, slots: {
    /**
     * NOTE: `ModalClose` forcefully sets `CloseIcon` as `children`, hence have to either
     * patch the @mui/joy package with `children || <CloseIcon />` or use a custom component
     * to also ignore the children and override with an explicit icon.
     */
    root: f
  }, children: m });
});
u.displayName = "DqSidePanelClose";
export {
  u as default
};
//# sourceMappingURL=DqSidePanelClose.js.map
